import React from "react";
import { AuthProvider } from "./contexts/AuthContext";
import { ContentProvider } from "./contexts/ContentContext";
import { TemplateProvider } from "./contexts/TemplateContext";
import Routes from "./Routes";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <TemplateProvider>
          <Routes />
        </TemplateProvider>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
